import { useId } from 'react';
import { DUOTONE_MAX_W, DUOTONE_MIN_W } from 'fe-design-base/assets/constants';
import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

const Missing = ({
  alt = 'Missing Illustration',
  ...props
}: IllustrationProps) => {
  const id = useId();
  return (
    <Box
      {...props}
      minw={DUOTONE_MIN_W}
      maxw={DUOTONE_MAX_W}
      className={`FDBIllustration${
        props?.className ? ` ${props.className}` : ''
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="100%"
        fill="none"
        role="img"
        aria-labelledby={id}
      >
        <title id={id}>{alt}</title>
        <path
          fill="#1E0B3A"
          d="M1.763 21.75c.769 0 1.415-.58 1.547-1.34a20.91 20.91 0 0 1 3.515-8.503c.441-.629.403-1.5-.14-2.044-.628-.628-1.669-.581-2.185.14A23.84 23.84 0 0 0 .32 20.1c-.15.882.552 1.65 1.443 1.65ZM11.907 6.825A20.96 20.96 0 0 1 20.4 3.3c.77-.122 1.35-.768 1.35-1.537 0-.89-.768-1.594-1.64-1.444A23.828 23.828 0 0 0 10.004 4.5c-.722.516-.77 1.557-.141 2.185.544.543 1.415.59 2.044.14ZM26.25 46.238c0 .89.77 1.594 1.641 1.444A23.91 23.91 0 0 0 37.988 43.5c.722-.515.769-1.556.14-2.184-.543-.544-1.415-.59-2.043-.14A20.959 20.959 0 0 1 27.59 44.7c-.76.132-1.34.77-1.34 1.547v-.01Zm14.925-10.144c-.44.628-.403 1.5.141 2.044.628.628 1.669.581 2.184-.14A23.84 23.84 0 0 0 47.682 27.9c.14-.88-.553-1.64-1.444-1.64-.769 0-1.416.581-1.547 1.34a20.704 20.704 0 0 1-3.525 8.494h.01ZM9.863 41.316c-.628.628-.581 1.669.14 2.184A23.84 23.84 0 0 0 20.1 47.682c.882.14 1.641-.553 1.641-1.444 0-.769-.581-1.416-1.34-1.547a20.704 20.704 0 0 1-8.494-3.525c-.629-.44-1.5-.403-2.044.14v.01ZM4.5 37.997c.516.722 1.557.769 2.185.14.543-.543.59-1.415.14-2.043a20.91 20.91 0 0 1-3.515-8.503c-.132-.76-.778-1.34-1.547-1.34-.89 0-1.594.768-1.444 1.64A23.828 23.828 0 0 0 4.5 37.997ZM38.138 6.685c.628-.628.581-1.669-.14-2.185A23.84 23.84 0 0 0 27.9.32c-.88-.15-1.65.552-1.65 1.443 0 .769.582 1.415 1.341 1.547a20.91 20.91 0 0 1 8.503 3.515c.628.441 1.5.403 2.044-.14Zm3.037 5.222A20.959 20.959 0 0 1 44.7 20.4c.132.76.77 1.341 1.547 1.341.89 0 1.594-.769 1.444-1.64a23.91 23.91 0 0 0-4.181-10.097c-.516-.722-1.556-.77-2.185-.141-.543.544-.59 1.415-.14 2.044h-.01Z"
        />
        <path
          fill="#7E3DD4"
          d="M41.175 11.907A20.961 20.961 0 0 1 44.7 20.4c.131.76.769 1.34 1.547 1.34.89 0 1.594-.768 1.444-1.64a23.91 23.91 0 0 0-4.181-10.097c-.516-.722-1.557-.769-2.185-.14-.544.543-.59 1.415-.14 2.043h-.01Z"
        />
      </svg>
    </Box>
  );
};

export default Missing;
